module.exports = __webpack_public_path__ + "img/sheet.f9691894.png";